<template>
  <div>
    <v-dialog v-model="dialog" eager persistent scrollable max-width="500">
      <v-form ref="CompanyProfileFormRef" @submit.prevent>
        <v-card>
          <v-card-title class="d-flex align-center">
            <span>{{ action }} Company Profile</span>
            <v-spacer></v-spacer>
            <v-btn
              icon="mdi-close"
              variant="text"
              color="white"
              @click="closeD()"
            >
            </v-btn>
          </v-card-title>

          <v-card-text style="max-height: 700px" class="">
            <v-container>
              <v-row>
                <v-col cols="12">
                  <v-text-field
                    v-model="name"
                    label="Company Name"
                    :rules="[formRules.required]"
                    outlined
                    density="compact"
                    variant="outlined"
                    class="mb-3"
                  />
                </v-col>
                <v-col cols="12">
                  <v-text-field
                    v-model="description"
                    label="Company Description"
                    :rules="[formRules.required]"
                    outlined
                    density="compact"
                    variant="outlined"
                    class="mb-3"
                  />
                </v-col>
                <v-col cols="12">
                  <v-text-field
                    v-model="email"
                    label="Company Email"
                    :rules="[formRules.required]"
                    outlined
                    density="compact"
                    variant="outlined"
                    class="mb-3"
                  />
                </v-col>
                <v-col cols="12">
                  <v-text-field
                    v-model="address"
                    label="Company Address"
                    :rules="[formRules.required]"
                    outlined
                    density="compact"
                    variant="outlined"
                    class="mb-3"
                  />
                </v-col>
                <v-col cols="12">
                  <v-text-field
                    v-model="website"
                    label="Company Website"
                    :rules="[formRules.required]"
                    outlined
                    density="compact"
                    variant="outlined"
                    class="mb-3"
                  />
                </v-col>
                <!-- <v-col cols="12">
                  <v-text-field
                    v-model="contact_person"
                    label="Contact Person"
                    :rules="[formRules.required]"
                    outlined
                    density="compact"
                    variant="outlined"
                    class="mb-3"
                  />
                </v-col>
                <v-col cols="12">
                  <v-text-field
                    v-model="contact_person_position"
                    label="Contact Person Position"
                    :rules="[formRules.required]"
                    outlined
                    density="compact"
                    variant="outlined"
                    class="mb-3"
                  />
                </v-col>
                <v-col cols="12">
                  <v-text-field
                    v-model="phone_no"
                    label="Phone Number"
                    :rules="[formRules.required]"
                    outlined
                    density="compact"
                    variant="outlined"
                    class="mb-3"
                  />
                </v-col> -->
                <v-col cols="12">
                  <div class="text-subtitle-1 font-weight-bold">
                    About Company
                  </div>
                  <v-textarea
                    v-model="about_company"
                    rows="5"
                    variant="outlined"
                    placeholder="Type here..."
                  ></v-textarea>
                </v-col>
              </v-row>
            </v-container>
          </v-card-text>
          <v-divider></v-divider>

          <v-card-actions class="pa-2 mr-4">
            <v-spacer></v-spacer>
            <v-btn outlined @click="closeD()">
              <v-icon>mdi-close-circle-outline</v-icon>
              Cancel
            </v-btn>
            <v-btn
              :color="$vuetify.theme.themes.light.submitBtnsGreen"
              class="white--text"
              density="comfortable"
              variant="flat"
              :disabled="btnLoading"
              :loading="btnLoading"
              @click="save()"
            >
              <v-icon>mdi-check-circle</v-icon>
              Save
            </v-btn>
          </v-card-actions>
        </v-card>
      </v-form>
    </v-dialog>

    <fade-away-message-component
      displayType="default"
      v-model="fadeAwayMessage.show"
      :message="fadeAwayMessage.message"
      :header="fadeAwayMessage.header"
      :type="fadeAwayMessage.type"
    ></fade-away-message-component>
  </div>
</template>

<script>
import eventBus from "@/eventBus";
export default {
  props: {
    data: Object,
    action: String,
    title: String,
    typeToSave: String,
  },
  data() {
    return {
      dialog: false,
      showDatePicker: false,
      btnLoading: false,
      name: null,
      address: null,
      description: null,
      website: null,
      email: null,
      contact_person: null,
      contact_person_position: null,
      about_company: null,
      phone_no: null,
      fadeAwayMessage: {
        show: false,
        type: "success",
        header: "Successfully Added!",
        message: "",
        top: 10,
      },
    };
  },
  watch: {
    data: {
      handler(data) {
        this.dialog = true;
        this.initialize();

        if (!data.id) {
          this.initialize();
        }
      },
      deep: true,
    },
  },
  methods: {
    setValue(type, score) {
      if (type == "quality of work") {
        this.quality_of_work = score;
      }
      if (type == "punctuality") {
        this.punctuality = score;
      }
      if (type == "initiative") {
        this.initiative = score;
      }
      if (type == "teamwork") {
        this.teamwork = score;
      }
    },

    initialize() {
      this.axiosCall("/organization/getInfo", "GET").then((res) => {
        if (res.data) {
          console.log("org", res.data);
          this.name = res.data.name;
          this.address = res.data.address;
          this.description = res.data.description;
          this.website = res.data.website;
          this.email = res.data.email;
          this.contact_person = res.data.contact_person;
          this.phone_no = res.data.phone_no;
          this.contact_person_position = res.data.contact_person_position;
          this.about_company = res.data.about_company;
        }
      });
    },

    async save() {
      let formValid = await this.$refs.CompanyProfileFormRef.validate();

      if (formValid.valid) {
        this.btnLoading = true;
        let data = {
          name: this.name,
          description: this.description,
          about_company: this.about_company,
          email: this.email,
          website: this.website,
          address: this.address,
          contact_person: this.contact_person,
          contact_person_position: this.contact_person_position,
          phone_no: this.phone_no,
        };

        this.axiosCall("/organization/updateProfile", "PATCH", data).then(
          (res) => {
            console.log(res);
            if (res.data.status == 200) {
              this.fadeAwayMessage.show = true;
              this.fadeAwayMessage.type = "success";
              this.fadeAwayMessage.message = res.data.msg;
              this.fadeAwayMessage.header = "System Message";
              this.btnLoading = false;
              this.closeD();
            } else {
              this.btnLoading = false;
              this.fadeAwayMessage.show = true;
              this.fadeAwayMessage.type = "error";
              this.fadeAwayMessage.message = res.data.msg;
              this.fadeAwayMessage.header = "System Message";
            }
          },
        );
      }
    },

    closeD() {
      eventBus.emit("closeUpdateCompanyProfileDialog", true);
      this.btnLoading = false;
      this.dialog = false;
    },

    getPrograms() {
      this.axiosCall("/program", "GET").then((res) => {
        this.programsList = res.data;
      });
    },
  },
};
</script>

<style scoped>
.tbl {
  width: 100%;
  border-collapse: collapse;
}
</style>
